import React from "react";

export default function SQLServer_NCHAR() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_NCHAR</h1>
      <p>This is the SQLServer_NCHAR component generated from the SQL JSON.</p>
    </div>
  );
}
